import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { theme } from 'antd';
import { RootState } from 'store/configureStore';
import { TitleList } from 'store/ducks/globalTypes';
import TitleBar from 'components/TitleBar';
import dataManagementAreas from 'constants/dataManagementAreas';
import { getDataManagementAreasContent } from 'constants/dataManagementAreasContent';
import CardComponent from 'components/CardComponent';
import * as Styled from '../Layout.styled';
import { useTranslation } from 'react-i18next';

const { useToken } = theme;

const DataManagementLayout: React.FC = () => {
  const { token } = useToken();
  const { scheme } = useSelector((state: RootState) => state.global);
  const areas = dataManagementAreas();
  const { t } = useTranslation();
  const dataEntryAreasContent = getDataManagementAreasContent(t);

  return (
    <Styled.StyledLayout token={token}>
      <TitleBar title={t(TitleList.MASTER_DATA)} />
      <Styled.HorizontalLayoutMain theme={scheme}>
        <Styled.Container>
          <Styled.GridContainer token={token}>
            {dataEntryAreasContent.map((item: any, index: number) => (
              <Styled.CardItemWrapper key={item.area}>
                <CardComponent
                  area={item.title}
                  infoText={item.infoText}
                  href={item.href}
                  textOnTop=""
                  minHeight="100px"
                />
              </Styled.CardItemWrapper>
            ))}
          </Styled.GridContainer>
        </Styled.Container>
      </Styled.HorizontalLayoutMain>
    </Styled.StyledLayout>
  );
};

export default DataManagementLayout;
